import {
  Button,
  CircularProgress,
  IconButton,
  makeStyles,
  useMediaQuery,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { Add, Delete, Edit } from "@material-ui/icons";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { listEmailTypes, deleteEmailType } from "../Services/EmailTypeService";
import MUIDataTable from "mui-datatables";
import { Grid } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { BsPlus } from "react-icons/bs";
import EmailView from "./EmailView";
import { getUserData, getRowData } from "../../utils/FunctionHelpers";
import '../Dashboard/dashboardStyle.css'
import { theme } from "../../utils/Theme";
import { handleOnViewColumnsChange, displayColumn } from "../../utils/viewColumns";
import "./emailType.css"
import DialogDeleteCustom from "../../components/DialogDeleteCustom/DialogDeleteCustom";
import { withSnackbar } from "../../utils/SnackbarHOC";


const useStyles = makeStyles(() => ({
  buttonProgress: {
    color: "rgb(17, 122, 167)",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
    fontSize: "17px",
  },
  archiveButton: {
    color: "white",
    fontWeight: 500,
    backgroundColor: "rgb(17, 122, 167)",
    marginBottom: "10px",
    "&:hover": {
      backgroundColor: "rgb(17, 122, 167)"
    }
  },
  butnStyle: {
    fontFamily: 'myFirstFont',
  },
  EDITbutton: {
    color: "rgb(245 146 0)",
  },
  messagePreview: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "300px",
    cursor: "pointer",
    color: "rgb(17, 122, 167)",
    textDecoration: "underline dotted",
    "&:hover": {
      opacity: 0.8,
    },
  },
}));

const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
};

const EmailTypeList = ({ history, editMode, snackbarShowMessage }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [messageInfos, setMessageInfos] = useState({ uuid: "", msgName: "" });
  const [loadingToDelete, setLoadingToDelete] = useState(false);
  const classes = useStyles();
  const [reloadData, setReloadData] = useState(false);
  const [messageDialog, setMessageDialog] = useState({ open: false, text: "" });

  const editEmailType = (uuid) => {
    history.push({
      pathname: `/emailtype/${uuid}/edit`,
    });
  };

  const handleOpenDialog = (uuid, msgName) => {
    setOpenDialogDelete(true);
    setMessageInfos({ uuid, msgName});
  };

  const handleCloseDialog = () => {
    if (loadingToDelete) {
      return;
    }
    setOpenDialogDelete(false);
  };

  const handleDeleteEmailType = () => {
    (async () => {
      setLoadingToDelete(true);
      try {
        snackbarShowMessage("Patientez svp!", "warning", null);
        const res = await deleteEmailType(messageInfos.uuid);
        snackbarShowMessage(res.data, "success", 4000);
        setLoadingToDelete(false);
        handleCloseDialog();
        setReloadData(!reloadData);
      } catch (error) {
        snackbarShowMessage("une erreur est survenue: " + error.message, "error", 4000);
        setLoadingToDelete(false);
      }
    })();
  };

  React.useEffect(() => {
    let active = true;

    (async () => {
      setLoading(true);
      setMessages([]);
      try {
        let newContacts = await listEmailTypes();

        if (!active) {
          return;
        }

        setMessages(newContacts.data);
        setLoading(false);
      } catch (error) {
        snackbarShowMessage("Erreur de chargement des email types!", "error", 4000);
        setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadData]);

  const tableName = "emailColumnVisibility"
  const columns = [
    {
      name: "uuid",
      label: "N°EMAILTYPE",
      options: {
        display: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", width: "100px" }}>{value !== null ? value : "---"}</Box>
            </>
          );
        },
      },
    },
    {
      name: "activite",
      label: "ACTIVITE",
      options: {
        display: displayColumn("activite", tableName),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textTransform: "capitalize" }}>{value}</Box>
            </>
          );
        },
      },
    },
    {
      name: "TypeMsg",
      label: "TYPE",
      options: {
        display: displayColumn("TypeMsg", tableName),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", textTransform: "uppercase" }}>{value}</Box>
            </>
          );
        },
      },
    },
    {
      name: "msgName",
      label: "INTITULÉ DU MESSAGE",
      options: {
        display: displayColumn("msgName", tableName),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>{value}</Box>
            </>
          );
        },
      },
    },
    {
      name: "objet",
      label: "OBJET DU MAIL",
      options: {
        display: displayColumn("objet", tableName),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Box data-toggle="tooltip" title={value} style={{ whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>
                {value ? value : "-"}
              </Box>
            </>
          );
        },
      },
    },
    {
      name: "message",
      label: "CONTENU DU MESSAGE",
      options: {
        display: displayColumn("message", tableName),
        customBodyRender: (value, tableMeta, updateValue) => {
          const plainText = stripHtml(value);
          const preview = plainText.length > 80 ? plainText.substring(0, 80) + "…" : plainText;
          return (
            <Box
              className={classes.messagePreview}
              onClick={() => plainText && setMessageDialog({ open: true, text: plainText })}
            >
              {preview || "-"}
            </Box>
          );
        },
      },
    },
    {
      name: "actions",
      label: "ACTIONS",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = getRowData(tableMeta, columns);
          return (
            <>
              <EmailView
                activite={row.activite}
                msgName={row.msgName}
                objet={row.objet}
                message={row.message}
                TypeMsg={row.TypeMsg}
              />
              <IconButton data-toggle="tooltip" title="Modifier" onClick={() => editEmailType(row.uuid)} >
                <Edit className={classes.EDITbutton} />
              </IconButton>
              {localStorage.getItem("rolecurrentuser") === "ROLE_ADMIN" &&
                getUserData().uuid !== row.uuid && (
                  <IconButton
                    data-toggle="tooltip"
                    title="Supprimer"
                    onClick={() => handleOpenDialog(row.uuid, row.msgName)}
                    style={{ color: "#EF6262" }}
                  >
                    <Delete />
                  </IconButton>
                )
              }
            </>
          );
        },
      },
    },
  ];

  const isSmMode = useMediaQuery(theme.breakpoints.between(376, 767));


  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  React.useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isSmall = useMediaQuery((theme) => theme.breakpoints.between(0, 767));
  const isMediumMode = useMediaQuery((theme) => theme.breakpoints.between(767, 1023));
  const isLargeMode = useMediaQuery((theme) => theme.breakpoints.between(1023, 2800));
  const tableBodyMaxHeight = `${isSmall ? viewportHeight - 292 : isMediumMode ? viewportHeight - 298 : isLargeMode ? viewportHeight - 255 : 200}px`;

  const options = {
    rowsPerPageOptions: [],
    rowsPerPage: 50,
    tableBodyMaxHeight: tableBodyMaxHeight,
    textLabels: {
      body: {
        noMatch: loading ? <CircularProgress /> : "Désolé, il n'y a aucun enregistrement dans la base de données pour le moment.",
      },
    },
    selectableRows: "none",
    draggableColumns: {
      enabled: true,
    },
    onViewColumnsChange: (columnName, action) => {
      handleOnViewColumnsChange(columnName, action, tableName);
    },
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
  };

  const dialogDeleteProps = {
    handleClose: handleCloseDialog,
    handleOpen: openDialogDelete,
    handleDelete: handleDeleteEmailType,
    loading: loadingToDelete,
    label: `Voulez vous vraiment supprimer le message?`,
    title: "Supprimer le message",
  };

  return (
    <Box sx={{ padding: "0 20px" }}>
      <Grid container style={{ paddingBottom: "5px" }}>
        <Grid item xs={10} sm={9} md={9} xl={6}>
          <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
            <h2 className="text-capitalize" style={{ color: "rgb(17, 122, 167)" }}>
              LISTE DES MESSAGES TYPES
            </h2>
          </Box>
        </Grid>
        <Grid item xs={2} sm={3} md={3} xl={6}>
          <Box sx={{ display: "flex", justifyContent: "end" }}
          >
            {!isSmMode ? <Button
              className={classes.archiveButton}
              startIcon={<BsPlus size={22} />}
              onClick={() => history.push("/emailtype/add")}
            >
              AJOUTER
            </Button>
              : <IconButton data-toggle="tooltip"
                title="Delete" aria-label="delete" onClick={() => history.push("/emailtype/add")} size="medium" >
                <Add />
              </IconButton>}
          </Box>
        </Grid>
      </Grid>

      <Box className="messageType_container">
        <DialogDeleteCustom {...dialogDeleteProps} />
        <MUIDataTable data={messages} columns={columns} options={options} />
      </Box>

      <Dialog
        open={messageDialog.open}
        onClose={() => setMessageDialog({ open: false, text: "" })}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { borderRadius: "10px" } }}
      >
        <DialogTitle style={{ backgroundColor: "rgb(17, 122, 167)", color: "#fff", padding: "14px 24px" }}>
          <Typography variant="h6" style={{ fontSize: "1rem", fontWeight: 600 }}>
            Contenu du message
          </Typography>
        </DialogTitle>
        <DialogContent dividers style={{ overflowY: "auto", maxHeight: "60vh", padding: "20px 24px" }}>
          <Typography variant="body2" style={{ whiteSpace: "pre-wrap", lineHeight: 1.8, fontSize: "0.9rem", color: "#333" }}>
            {messageDialog.text}
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: "10px 16px" }}>
          <Button
            onClick={() => setMessageDialog({ open: false, text: "" })}
            style={{ color: "rgb(17, 122, 167)", fontWeight: 600 }}
          >
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </Box >
  );
};

export default withRouter(withSnackbar(EmailTypeList));
